import { updateEventCount } from "@/store/common";
import { sendEvent as sendEventApi } from "@/utils/dodo";
import { useMutation } from "@tanstack/react-query";
import { useDispatch } from "react-redux";

export default function useSendEvent() {

  const dispatch = useDispatch();
  const { mutate: sendEvent, isPending } = useMutation({
    mutationFn: sendEventApi,
    onSuccess: () => {
      dispatch(updateEventCount());
    }
  });
  return { sendEvent, isPending };
}
